<template>
    <div class="card p-3 border-radius-xl" data-animation="FadeIn">
        <h5 class="font-weight-bolder mb-0">Fale Conosco</h5>
        <p class="mb-0 text-sm">Canais de atendimento</p>
        <div class="">
            <div class="row">
                <div class="mx-auto col-md-12">
                    <div class="row flex-wrap mb-4">
                        <div class="d-flex justify-content-center mt-2 col-lg-4 col-md-6 col-sm-12">
                            <div class="d-flex justify-content-start">
                                <div class="mt-4" style="margin-left: 20px; margin-right: 20px;">
                                    <h5 class="segment-primary-color">Brasília</h5>
                                    <span class="segment-secondary-color" style="opacity: 60%;">Telefone</span> <br>
                                    <span class="segment-primary-color">(61) 4020-0020</span><br><br>
                                    <span class="segment-secondary-color" style="opacity: 60%;">E-mail</span> <br>
                                    <span class="segment-primary-color">clientedf@brasal.com.br</span>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-center mt-2 col-lg-4 col-md-6 col-sm-12">
                            <div class="d-flex justify-content-start">
                                <div class="mt-4" style="margin-left: 20px; margin-right: 20px;">
                                    <h5 class="segment-primary-color">Goiânia</h5>
                                    <span class="segment-secondary-color" style="opacity: 60%;">Telefone</span> <br>
                                    <span class="segment-primary-color">(62) 3997-2650</span><br><br>
                                    <span class="segment-secondary-color" style="opacity: 60%;">E-mail</span> <br>
                                    <span class="segment-primary-color">clientego@brasal.com.br</span>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-center mt-2 col-lg-4 col-md-6 col-sm-12">
                            <div class="d-flex justify-content-end">
                                <div class="mt-4" style="margin-left: 20px; margin-right: 20px;">
                                    <h5 class="segment-primary-color">Uberlândia</h5>
                                    <span class="segment-secondary-color" style="opacity: 60%;">Telefone</span> <br>
                                    <span class="segment-primary-color">(34) 2512-0200</span><br><br>
                                    <span class="segment-secondary-color" style="opacity: 60%;">E-mail</span> <br>
                                    <span class="segment-primary-color">clientemg@brasal.com.br</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>